import React from 'react';
import { Building2 } from 'lucide-react';
import { CompanyInfoFormProps, SelectOption } from '../types';

const CompanyInfoForm: React.FC<CompanyInfoFormProps> = ({
    companyInfo,
    onInfoChange,
    disabled = false
}) => {
    const industries: SelectOption[] = [
        { value: 'technology', label: 'Technology' },
        { value: 'manufacturing', label: 'Manufacturing' },
        { value: 'retail', label: 'Retail' },
        { value: 'financial', label: 'Financial Services' },
        { value: 'healthcare', label: 'Healthcare' },
        { value: 'energy', label: 'Energy' },
        { value: 'real_estate', label: 'Real Estate' },
        { value: 'utilities', label: 'Utilities' },
        { value: 'telecommunications', label: 'Telecommunications' },
        { value: 'other', label: 'Other' }
    ];

    return (
        <div className="card">
            <div className="card-header">
                <div className="flex items-center gap-2">
                    <Building2 className="w-5 h-5 text-blue-600" />
                    <h2 className="card-title">Company Information</h2>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="form-group">
                    <label className="form-label" htmlFor="companyName">
                        Company Name *
                    </label>
                    <input
                        type="text"
                        id="companyName"
                        className="form-input"
                        value={companyInfo.companyName}
                        onChange={(e) => onInfoChange('companyName', e.target.value)}
                        placeholder="Enter company name"
                        disabled={disabled}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="form-label" htmlFor="industry">
                        Industry *
                    </label>
                    <select
                        id="industry"
                        className="form-select"
                        value={companyInfo.industry}
                        onChange={(e) => onInfoChange('industry', e.target.value)}
                        disabled={disabled}
                    >
                        {industries.map(industry => (
                            <option key={industry.value} value={industry.value}>
                                {industry.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};

export default CompanyInfoForm;
